var map = {
	"./1.jpg": 8867,
	"./2.jpg": 3487,
	"./3.jpg": 6518,
	"./A1.jpg": 6132,
	"./A2.jpg": 9734,
	"./A3.jpg": 7017,
	"./A4.jpg": 2871,
	"./A5.jpg": 1760,
	"./A6.jpg": 5165,
	"./A7.jpg": 2775,
	"./A8.jpg": 8171,
	"./A9.jpg": 5738,
	"./B1.jpg": 549,
	"./B2.jpg": 5587,
	"./B3.jpg": 3040,
	"./B4.jpg": 7754,
	"./B5.jpg": 7354,
	"./B6.jpg": 3038,
	"./B7.jpg": 5882,
	"./B8.jpg": 5728,
	"./B9.jpg": 4225,
	"./C1.jpg": 8634,
	"./C2.jpg": 5983,
	"./C4.jpg": 5703,
	"./C5.jpg": 6862,
	"./C6.jpg": 6006,
	"./C7.jpg": 9416,
	"./C8.jpg": 5878,
	"./C9.jpg": 6424,
	"./D1.jpg": 9591,
	"./D2.jpg": 3135,
	"./Globalop.jpg": 3974,
	"./abroad.jpg": 9364,
	"./cloud.jpg": 9814,
	"./codertine.jpg": 2343,
	"./computertrends.jpg": 9518,
	"./consolation.jpg": 9373,
	"./cube.jpg": 7019,
	"./dataanalytics.jpg": 5086,
	"./dsa.jpg": 664,
	"./e1.jpg": 7470,
	"./e2.jpg": 4291,
	"./e3.jpg": 3522,
	"./e4.jpg": 5789,
	"./e5.jpg": 4934,
	"./e6.jpg": 3365,
	"./echo.jpg": 6746,
	"./endeavour.jpg": 5250,
	"./entrepreneur.jpg": 8712,
	"./foreignexchange.jpg": 1177,
	"./fresher.jpg": 3081,
	"./girl.jpg": 3592,
	"./global.jpg": 7843,
	"./google.jpg": 9666,
	"./gre.jpg": 9440,
	"./idea.jpg": 2421,
	"./jenga.jpg": 3933,
	"./life.jpg": 7207,
	"./matic.jpg": 4807,
	"./portis.jpg": 1123,
	"./projectdrive.jpg": 6545,
	"./prototype.jpg": 7085,
	"./recursion.jpg": 28,
	"./tezos.jpg": 3461,
	"./valedictory.jpg": 7736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9506;